import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import esApiMessages from './locales/es/apiMessages.json';

const enApiMessages = Object.fromEntries(
  Object.keys(esApiMessages).map((message) => [message, message]),
);

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: { ...enTranslation, ...enApiMessages } },
    es: { translation: { ...esTranslation, ...esApiMessages } },
  },
  lng: 'es',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
